import { render, staticRenderFns } from "./ModalAuctionBids.vue?vue&type=template&id=2dee59da"
import script from "./ModalAuctionBids.vue?vue&type=script&lang=js"
export * from "./ModalAuctionBids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports